export default "__VITE_PUBLIC_ASSET__7f101619__"